import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { cliqueInteresseSimulacao, visitaInteresseSimulacao } from "../services/api";
import { useAuth } from "../context/AuthContext";
import SimulacaoPublicaForm from "../components/SimulacaoPublicaForm";

// 🧪 Passo a passo do piloto "Simular uma entrevista" (23/10/2026). Nelson: o roteiro vai por e-mail a quem quiser
// testar — o e-mail leva só o link desta página, e o post da enquete avisa que ele chega ao criar a conta de empresa.
// Tudo aqui descreve o que JÁ está no ar (SimularEntrevista.jsx / SimulacaoEndpoints.cs); se o fluxo mudar, mude aqui.
// 23/10/2026 (Nelson): durante o PILOTO, testa quem quiser, SEM conta (formulário abaixo). Empresa logada continua
// podendo pelo painel (Entrevistas › 🧪 Simular uma entrevista).
const PASSOS = [
  ["Preencha o formulário abaixo", "O seu nome e e-mail, o nome e o e-mail de um colega que vai fazer o papel de candidato, e “Agora” ou um horário."],
  ["Confirme o seu e-mail", "Mandamos um link para você. Só depois da confirmação o convite vai para o colega (assim ninguém usa o seu e-mail sem você saber)."],
  ["Cada um entra pelo seu link", "Você e o colega recebem por e-mail o convite para a agenda e o link da sala, sem precisar criar conta."],
  ["Libere câmera e microfone", "A sala abre 15 minutos antes do horário. Quando o navegador pedir, permita a câmera e o microfone."],
  ["Aceite o feedback da IA", "Na entrada aparece “Quer receber feedback?”. Para testar a parte da IA, os dois aceitam."],
  ["Faça a entrevista", "Conduza como se fosse real. A conversa dura até 15 minutos: a sala fecha sozinha quando o tempo acaba."],
];

export default function SimulacaoGuiaPage() {
  // 23/10/2026: o botão "Quero testar" do e-mail às parceiras traz ?interesse=<código>.
  // ABRIR a página registra só uma VISITA: o antivírus do e-mail corporativo (Defender/Mimecast) abre todo link para
  // inspecionar e virava "clique" (8 entre 1 e 6 min depois do envio). Só o clique HUMANO em "Sim, quero testar"
  // confirma o interesse (e só ele avisa o Nelson). Visita: uma vez por aba, para recarregar não somar à toa.
  const [params] = useSearchParams();
  const interesse = params.get("interesse");
  const { user } = useAuth();
  const empresaLogada = user?.tipo === 1;   // TipoUsuario.Empresa
  const chaveOk = interesse ? `interesse-sim-ok:${interesse}` : null;
  const [estado, setEstado] = useState(() => {
    try { return chaveOk && sessionStorage.getItem(chaveOk) ? "anotado" : "pergunta"; } catch { return "pergunta"; }
  });
  useEffect(() => {
    if (!interesse) return;
    const chave = `interesse-sim:${interesse}`;
    try { if (sessionStorage.getItem(chave)) return; sessionStorage.setItem(chave, "1"); } catch { /* sem storage: registra mesmo assim */ }
    visitaInteresseSimulacao(interesse).then((r) => { if (r && r.confirmado) setEstado("anotado"); }).catch(() => {});
  }, [interesse]);
  const confirmar = async () => {
    setEstado("enviando");
    try {
      await cliqueInteresseSimulacao(interesse);
      try { sessionStorage.setItem(chaveOk, "1"); } catch { /* sem storage */ }
      setEstado("anotado");
    } catch {
      setEstado("erro");
    }
  };
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-8">
        {interesse && estado !== "anotado" && (
          <section className="rounded-2xl border border-primary/30 bg-white shadow-sm p-5 mb-6">
            <p className="font-bold text-text text-lg">Que bom que você veio! Confirma que quer participar do piloto?</p>
            <button type="button" onClick={confirmar} disabled={estado === "enviando"}
              className="mt-3 rounded-xl bg-primary px-5 py-2.5 font-semibold text-white disabled:opacity-60">
              {estado === "enviando" ? "Enviando…" : "Sim, quero testar"}
            </button>
            {estado === "erro" && <p className="mt-2 text-sm text-red-700">Não consegui registrar agora. Tente de novo em instantes.</p>}
          </section>
        )}
        {interesse && estado === "anotado" && (
          <section className="rounded-2xl border border-green-200 bg-green-50 p-4 mb-6 text-green-900">
            <p className="font-semibold">Anotado! Siga o passo a passo abaixo.</p>
          </section>
        )}
        <p className="text-xs font-bold tracking-widest text-accent uppercase">Piloto</p>
        <h1 className="text-3xl font-extrabold text-text mt-1">🧪 Como testar a entrevista pelo eaiRH</h1>
        <p className="text-gray-700 mt-3">
          Faça uma entrevista de teste dentro do portal com um colega da sua empresa no papel de candidato, e vejam na
          prática o agendamento, a sala de vídeo e o feedback da IA para os dois lados.
        </p>

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-6">
          <h2 className="font-bold text-text text-lg">O que você precisa</h2>
          <ul className="mt-2 space-y-1.5 text-gray-700 text-sm list-disc pl-5">
            <li>Só o seu e-mail e o de um colega. Não precisa criar conta durante o piloto.</li>
            <li>Um colega para fazer o papel de candidato. Ele não precisa criar conta.</li>
            <li>Computador ou celular com câmera e microfone, de preferência no Chrome ou no Edge.</li>
            <li>Uns 20 minutos: a conversa dura até 15 minutos.</li>
          </ul>
        </section>

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-4">
          <h2 className="font-bold text-text text-lg">Passo a passo</h2>
          <ol className="mt-3 space-y-3">
            {PASSOS.map(([t, d], i) => (
              <li key={t} className="flex gap-3">
                <span className="shrink-0 w-7 h-7 rounded-full bg-primary text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
                <div><p className="font-semibold text-text">{t}</p><p className="text-sm text-gray-700">{d}</p></div>
              </li>
            ))}
          </ol>
        </section>

        {/* empresa logada: o caminho de sempre, pelo painel; os demais testam aqui mesmo, sem conta */}
        {empresaLogada ? (
          <section className="rounded-2xl border border-primary/30 bg-white p-5 mt-6 text-sm">
            <p className="font-semibold text-text">Você já está na conta da empresa.</p>
            <p className="text-gray-600 mt-1">Use o painel: o teste fica junto das suas entrevistas, e dá para remarcar e acompanhar.</p>
            <Link to="/entrevistas" className="inline-block mt-3 bg-accent text-white font-bold rounded-lg px-5 py-2.5">Ir para o painel de entrevistas</Link>
          </section>
        ) : <SimulacaoPublicaForm />}

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-4">
          <h2 className="font-bold text-text text-lg">Depois da entrevista</h2>
          <ul className="mt-2 space-y-1.5 text-gray-700 text-sm list-disc pl-5">
            <li>Cada um recebe por e-mail o próprio feedback da IA: o colega, pontos de melhoria como candidato; você, um retorno sobre a condução da entrevista.</li>
            <li>O feedback pode levar algumas horas para chegar.</li>
          </ul>
        </section>

        <section className="rounded-2xl border border-amber-200 bg-amber-50 p-5 mt-4 text-sm text-amber-900">
          <h2 className="font-bold text-base">Bom saber</h2>
          <ul className="mt-2 space-y-1.5 list-disc pl-5">
            <li>É uma simulação: não aparece para candidatos, não tem vaga envolvida e não conta na reputação da empresa.</li>
            <li>Por ser piloto, a equipe do eaiRH pode ler o feedback desta simulação para melhorar a ferramenta.</li>
            <li>Limite do piloto: sem conta, 1 teste por e-mail a cada 7 dias; com conta de empresa, 3 por semana.</li>
          </ul>
        </section>

        <p className="text-gray-700 mt-6">
          Depois de testar, conta para a gente o que funcionou, o que travou e o que faltou: responda o e-mail ou escreva
          para <a href="mailto:comercial@eairh.com.br" className="text-primary underline">comercial@eairh.com.br</a>. É isso que vai moldar a versão final.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          {empresaLogada
            ? <Link to="/entrevistas" className="bg-accent text-white font-bold rounded-lg px-5 py-2.5">Simular uma entrevista</Link>
            : <a href="#testar" className="bg-accent text-white font-bold rounded-lg px-5 py-2.5">Testar agora, sem conta</a>}
          <Link to="/entrar?tipo=empresa&cadastro=1" className="border border-primary text-primary font-semibold rounded-lg px-5 py-2.5">Criar conta de empresa</Link>
        </div>
      </main>
    </div>
  );
}
